// extracted by mini-css-extract-plugin
export default {"number":"SequenceNumber-module__number__hCl+R","active":"SequenceNumber-module__active__KQBT+","disabled":"SequenceNumber-module__disabled__NS6I6"};